// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"d4af749a","653":"7209a1b6","707":"69603aa8"}[chunkId] + ".chunk.js";
};